import { ModulePrefixes } from "enums";
import { t } from "i18next";
import LeftMenuCard from "leftMenu/LeftMenuCard";
import { useLocation } from "react-router-dom";
import { getSettingsMenu } from "staticData";

export default function SettingseMenu() {
  const { search } = useLocation();
  return (
    <>
      <div className="card-div">
        {getSettingsMenu()
          .filter((_) => _)
          .map((item, index) => (
            <LeftMenuCard
              key={`${index}-${item.module}`}
              {...item}
              title={t(item.title)}
              prefix={ModulePrefixes.ACCOUNT_SETTINGS}
              link={`${ModulePrefixes.ACCOUNT_SETTINGS}/${item.module}${
                search ?? ""
              }`}
            />
          ))}
      </div>
    </>
  );
}
